// extracted by css-extract-rspack-plugin
export default {"cls1":"RecommendationsCard-cls1_bOX","cls2":"RecommendationsCard-cls2_mIX RecommendationsCard-cls1_bOX"};